import React from 'react';
import { useTranslation } from 'react-i18next';
import { Folder, Plus } from 'lucide-react';

/**
 * The API Requests sidebar when no workspace is open: the active project (or
 * No project) has none, so ProjectScopeSync closed the previous project's
 * workspace instead of showing its collections (26.10.2026). Offers the same
 * create dialog as the switcher's "New workspace…"; a workspace created while
 * a project is active joins that project (ProjectScopeSync step 4).
 */
export default function NoWorkspaceSidebar({ onCreateWorkspace }) {
  const { t } = useTranslation();
  return (
    <div className="relative w-full h-full bg-gray-50 flex flex-col dark:bg-zinc-900" data-testid="no-workspace-sidebar">
      <div className="py-8 px-3 text-center">
        <div className="sidebar-empty-icon-wrap">
          <div className="sidebar-empty-icon">
            <Folder size={16} />
          </div>
        </div>
        <p className="mb-1 text-xs font-medium text-gray-600">{t('projectScope.noWorkspaces')}</p>
        <p className="mb-3 text-xs text-gray-500">{t('projectScope.noWorkspaceOpenHint')}</p>
        <button
          type="button"
          className="workspace-dropdown-create-btn inline-flex items-center space-x-2 p-2 rounded-lg text-sm"
          onClick={onCreateWorkspace}
        >
          <Plus size={16} aria-hidden />
          <span>{t('projectScope.newWorkspace')}</span>
        </button>
      </div>
    </div>
  );
}
